import { render, staticRenderFns } from "./Intervals.vue?vue&type=template&id=c5d89256"
import script from "./Intervals.vue?vue&type=script&lang=js"
export * from "./Intervals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports